import * as z from "zod";

export const updateGoogleMerchantCenterIntegration = {
  name: "updateGoogleMerchantCenterIntegration" as const,
  input: z.object({
    merchantId: z.string().optional(),
    ucpEnabled: z.boolean().optional(),
  }),
  output: z.object({ success: z.boolean() }),
};
